/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';

import { AppState } from '@api/store/app-store';
import * as ui from '@api/store/actions/ui.actions';

@Component({
  template: require('./page-not-found.component.html'),
  styles: [
    `
  .error-template {padding: 40px 15px;text-align: center;}
.error-actions {margin-top:15px;margin-bottom:15px;}
.error-actions .btn { margin-right:10px; }
`
  ]
})
export class PageNotFoundComponent implements AfterViewInit {
  hideSpinner = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>
  ) {}


  ngAfterViewInit(): void {
    this.store.dispatch(
      new ui.ShowProgressIndicatorAction({ status: false })
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/page-not-found.component.ts